<template>
  <div class="graphic-wrapper">
    <div class="select-row-wrapper">
      <div class="select-row">
          <quarter-select
            :aorb="'A'"
            :quarters="quarters"
            :current="currentA"
            :changeHandler="changeHandler">
          </quarter-select>
          <quarter-select
            :aorb="'B'"
            :quarters="quarters"
            :current="currentB"
            :changeHandler="changeHandler">
          </quarter-select>
        </div>
        <open-close-all
            :categories="categories">
        </open-close-all>
        <div class="compare-controls-right">
          <current-controls
            :grayscale="grayscale"
            :toggleScale="toggleScale"></current-controls>
        </div>
      </div>
      <category-row 
        v-for="(category, index) in categories" 
        :key="category.score"
        :category="category"
        :columnAScores="columnA.categories[index]"
        :columnBScores="columnB.categories[index]"
        :catIndex="index">
      </category-row>
  </div>
</template>

<script>
import CategoryRow from './CategoryRow';
import QuarterSelect from './QuarterSelect';
import OpenCloseAll from '../OpenCloseAll';
import CurrentControls from './CurrentControls';

export default {
  name: 'graphic-column',
  props: [
    'quarters',
    'riskData',
    'categories',
    'currentA',
    'currentB',
    'changeHandler',
    'toggleScale',
    'grayscale',
  ],
  components: {
    'category-row': CategoryRow,
    'quarter-select': QuarterSelect,
    'open-close-all': OpenCloseAll,
    'current-controls': CurrentControls,
  },
  methods: {
    getScoreObject(quarterObj) {
      const year = quarterObj.yearIndex;
      const quarter = quarterObj.quarterIndex;
      return this.riskData[year].quarters[quarter];
    },
  },
  computed: {
    columnA() {
      return this.getScoreObject(this.currentA);
    },
    columnB() {
      return this.getScoreObject(this.currentB);
    },
  },
};
</script>

<style lang="less">
  .graphic-wrapper {
    flex: 1 0;
    min-height: 400px;
  }
  .select-row {
    display: flex;
    justify-content: space-between;
    width: 27%;
    margin-bottom: 5px;
    @media(max-width: 800px) {
      width: 44%;
    }
    @media(max-width: 500px) {
      width: 100%;
      margin-top: 10px;
    }
  }
  .select-row-wrapper {
    display: flex;
    border-bottom: 1px solid #555;
    @media (max-width: 1100px) {
      flex-wrap: wrap;
    }
    @media (max-width: 700px) {
      flex-direction: column;
      flex-basis: auto;
      height: 232px;
    }
  }
  .compare-controls-right {
    display: flex;
    flex: 1 0;
    @media(min-width: 500px) and (max-width: 1100px) {
      flex: 1 0 100%;
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 10px;
    }
    @media(max-width: 1100px) {
      order: -1;
    }
  }
</style>



// WEBPACK FOOTER //
// GraphicColumn.vue?72b829b8